import { Component, OnInit } from '@angular/core';
import { PopupComponent } from '../../popup.component';

@Component({
    selector: 'ez-popup-delete-picture',
    template: require('./popup-delete-picture.component.html')
})
export class DeletePicturePopupComponent extends PopupComponent implements OnInit {
    private sentence: string = '';

    public ngOnInit() {
        if (this.popupService.hasData('sentence')) {
            this.sentence = this.popupService.getData('sentence');
        }
    }

    public accept() {
        this.sendResult({
            result: true
        });
    }

    public cancel() {
        this.sendResult({
            result: false
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/popup/types/deletePicture/popup-delete-picture.component.ts